import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {BehaviorSubject, Observable} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../../../src/environments/environment';
import {ReactiveService} from '../reactive-service.abstract';
import {EventModel} from './event.model';
import {forkJoin} from 'rxjs/internal/observable/forkJoin';

@Injectable()
export class EventsApiService extends ReactiveService  {
  private baseUrl = environment.backEndUrlPrefix + '/' + 'db/event';

  private selectedParamsSubject = new BehaviorSubject<EventModel[]>([]);
  selectedParams$ = this.selectedParamsSubject.asObservable();

  updateSelectedParams(params: EventModel[]) {
    this.selectedParamsSubject.next(params);
  }

  constructor(private http: HttpClient) {
    super();
  }

  getAll(notify?: boolean): Observable<EventModel[]> {
    if (notify === undefined || notify === true) {
      const params = new HttpParams().append('notify', 'true');
      return this.http.get<EventModel[]>(this.baseUrl, {params});
    } else if (notify === false) {
      return this.http.get<EventModel[]>(this.baseUrl);
    }
  }

  updateGroup(ids: number[], data): Observable<EventModel[]> {
    return this.http.patch<EventModel[]>(this.baseUrl, data, {params: {id: ids.map(id => id.toString())}});
  }


  deleteGroup(ids: number[]): Observable<any> {
    const reqs =  [];
    const l = 100;
    for (let i = 0; i < ids.length; i += l ) {
      const jds = [];
      for (let j = i; j < Math.min(ids.length, i + l); j++) {
        jds.push(ids[j]);
      }
      reqs.push(this.http.delete<string>(this.baseUrl, {params: {id: jds.map(id => String(id))}}));
    }
    return forkJoin(reqs);
/*
    return this.http.delete<string>(this.baseUrl, {params: {id: ids.map(id => String(id))}});
*/
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<EventModel[]> | Promise<EventModel[]> | EventModel[] {
    const notifyflag = route.data['notifyflag'];
    return this.getAll(notifyflag);
  }


}
